<mat-table mat-table [dataSource]="pausedDonations">
  <ng-container matColumnDef="donor">
    <mat-header-cell *matHeaderCellDef>full name</mat-header-cell>
    <mat-cell *matCellDef="let pausedDonation">{{ nameUtils.fullName(pausedDonation.donor) }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="emailaddress">
    <mat-header-cell *matHeaderCellDef>email address</mat-header-cell>
    <mat-cell *matCellDef="let pausedDonation">{{ pausedDonation.donor.emailAddress }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="amount">
    <mat-header-cell *matHeaderCellDef>amount</mat-header-cell>
    <mat-cell *matCellDef="let pausedDonation">{{ pausedDonation.amount | currency: 'EUR' }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="latestcomment">
    <mat-header-cell *matHeaderCellDef>reason</mat-header-cell>
    <mat-cell *matCellDef="let pausedDonation">{{ pausedDonation.latestComment }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="pausedon">
    <mat-header-cell class="o100w-date-column" *matHeaderCellDef>paused on</mat-header-cell>
    <mat-cell class="o100w-date-column" *matCellDef="let pausedDonation">{{
      pausedDonation.pausedOn | date: 'dd-MM-yyyy'
    }}</mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns" [routerLink]="['/donations', row.uuid]"> </mat-row>
</mat-table>
